export default __webpack_public_path__ + "static/media/DetailBackground.71533b90.jpg";